import React from 'react';
import PropTypes from 'prop-types';
import HSL from '@haptik/helpers/build/esm/hslBuilder';
import { isProduction } from '@src/utils';

import './BotBreakMessage.scss';

export default function BotBreakMessage({
  value,
  onChange,
  // allPlatforms = [],
}) {
  let botBreakMessage = value && value.length ? value : [''];
  if (botBreakMessage.asMutable) botBreakMessage = botBreakMessage.asMutable();

  return (
    <div className="botbreak-message">
      <HSL
        value={botBreakMessage}
        onChange={onChange}
        disabled={isProduction()}
        withVariants
        withReplies
      />
    </div>
  );
}

BotBreakMessage.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  allPlatforms: PropTypes.arrayOf(PropTypes.shape({})),
};

BotBreakMessage.defaultProps = {
  onChange: () => {},
  value: [''],
  allPlatforms: [],
};
